<div class="is-flex is-justify-space-between is-align-stretch gap-4">
  @for (day of forecastDays(); track day.day_ts; let i = $index) {
    @if (i < 5) {
      <div class="weather-icon is-flex is-column gap-2 is-justify-space-between is-align-center">
        <app-text class="is-family-semiBold text-12 text-grey-70" [class.text-netatmo-orange]="i === 0">
          {{ getDay(day.day_ts) }}
        </app-text>
        <div class="is-flex is-column gap-4 is-align-center">
          <app-weather-forecast-icon
            [ngClass]="{ 'is-loading is-relative': !day.max_temp && !day.min_temp }"
            [symbol]="day.weather_symbol_day"
            [width]="52"
            [height]="52"
          />

          <div class="is-flex is-column gap-4 is-align-center">
            <div class="is-flex text-14 is-family-medium">
              <app-text>{{ (day.max_temp | toUserUnit: type | toDisplayValue: type) ?? '--' }}</app-text>
              <app-text unit [measureType]="type" />
            </div>
            <div class="is-flex text-12 text-grey-70">
              <app-text>{{ (day.min_temp | toUserUnit: type | toDisplayValue: type) ?? '--' }}</app-text>
              <app-text unit [measureType]="type" />
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
